export default __webpack_public_path__ + "static/media/icon-poweredby.54a217fd5a86aa7d00218d9584694ac9.svg";